import {
  FDBox, FDContentContainer, FDPaper, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import React from 'react';
import { LottieLoadingLayout } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import useMobileLayout from 'Hooks/useMobileLayout';
import PropTypes from 'prop-types';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

export const AccountDebitTemplate = ({ children }) => {
  const isMobile = useMobileLayout();
  useBoneBackgroundColor();

  const [loading, setLoading] = React.useState(false);

  const { setPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  const {
    resource,
  } = useMetaLayoutContext();

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const nextStepColl = await resource.submit();
      setPageContentCollection(nextStepColl);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FDBox paddingY={isMobile ? 2 : 6}>
      <FDContentContainer maxWidth={'md'}>
        <LottieLoadingLayout>
          <FDPaper appearance={'elevated'} padding={2} flex={1}>
            <FDStack direction="column" spacing={2} alignItems={'center'} paddingY={4} paddingX={2}>
              {children}
              {resource.meta().canPost() ? <FDPrimaryActionButton
                size={'lg'}
                loading={loading}
                label={resource.attr('primaryActionText') || 'Continue'}
                onClick={handleConfirm}
              /> : null}
            </FDStack>
          </FDPaper>
          <FDStack direction="column" alignItems={'center'} paddingY={6}>
            <MetaControlField attr={'disclosure'} />
          </FDStack>
        </LottieLoadingLayout>
      </FDContentContainer>
    </FDBox>
  );
};

AccountDebitTemplate.propTypes = {
  children: PropTypes.node.isRequired,
};
